<template>
  <div class="finished-setup">
    <div class="finished-setup__saddle">
      <h3>{{ t('common.bike.saddle') }}</h3>
      <span
        v-if="
          finalMeasurement.saddle.active.SADDLE_BRAND ||
          finalMeasurement.saddle.active.SADDLE_MODEL
        "
        >{{
          `${finalMeasurement.saddle.active.SADDLE_BRAND} ${finalMeasurement.saddle.active.SADDLE_MODEL}`
        }}</span
      >
      <span v-else>-</span>
      <h4>{{ t('common.position.index') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.position.x') }}</span>
        <span v-if="finalMeasurement.saddle.x">{{
          `${finalMeasurement.saddle.x} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('common.position.y') }}</span>
        <span v-if="finalMeasurement.saddle.y">{{
          `${finalMeasurement.saddle.y} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <h4>{{ t('common.specs') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.size.width') }}</span>
        <span v-if="finalMeasurement.saddle.active.SADDLE_WIDTH">{{
          `${finalMeasurement.saddle.active.SADDLE_WIDTH} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.saddle.shape.index') }}</span>
        <span v-if="finalMeasurement.saddle.active.SHAPE">{{
          finalMeasurement.saddle.active.SHAPE
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.saddle.anatomical') }}</span>
        <span>{{
          finalMeasurement.saddle.active.ANATOMIC_DESIGN
            ? t('common.yes')
            : t('common.no')
        }}</span>
      </div>
    </div>

    <div class="finished-setup__handlebar">
      <h3>{{ t('common.bike.handlebar') }}</h3>
      <span
        v-if="
          finalMeasurement.handlebar.active.HANDLEBAR_BRAND ||
          finalMeasurement.handlebar.active.HANDLEBAR_MODEL
        "
        >{{
          `${finalMeasurement.handlebar.active.HANDLEBAR_BRAND} ${finalMeasurement.handlebar.active.HANDLEBAR_MODEL}`
        }}</span
      >
      <span v-else>-</span>
      <h4>{{ t('common.position.index') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.position.x') }}</span>
        <span v-if="finalMeasurement.handlebar.x">{{
          `${finalMeasurement.handlebar.x * -1} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('common.position.y') }}</span>
        <span v-if="finalMeasurement.handlebar.y">{{
          `${finalMeasurement.handlebar.y} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <h4>{{ t('common.specs') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.size.width') }}</span>
        <span v-if="finalMeasurement.handlebar.active.HANDLEBAR_WIDTH">{{
          `${finalMeasurement.handlebar.active.HANDLEBAR_WIDTH} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.handlebar.reach') }}</span>
        <span v-if="finalMeasurement.handlebar.active.HANDLEBAR_REACH">{{
          `${finalMeasurement.handlebar.active.HANDLEBAR_REACH} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.handlebar.drop') }}</span>
        <span v-if="finalMeasurement.handlebar.active.HANDLEBAR_DROP">{{
          `${finalMeasurement.handlebar.active.HANDLEBAR_DROP} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.handlebar.sweep') }}</span>
        <span v-if="finalMeasurement.handlebar.active.BACK_SWEEP_ANGLE">{{
          `${finalMeasurement.handlebar.active.BACK_SWEEP_ANGLE} ${t('common.unit.degreesSign')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('measurement.handlebar.flare') }}</span>
        <span v-if="finalMeasurement.handlebar.active.FLARE_ANGLE">{{
          `${finalMeasurement.handlebar.active.FLARE_ANGLE} ${t('common.unit.degreesSign')}`
        }}</span>
        <span v-else>-</span>
      </div>
    </div>

    <div class="finished-setup__crankset">
      <h3>{{ t('common.bike.crankset') }}</h3>
      <h4>{{ t('common.specs') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.bike.crankLength') }}</span>
        <span v-if="finalMeasurement?.crankset.active">{{
          `${finalMeasurement?.crankset.active} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
    </div>

    <div class="finished-setup__pedals">
      <h3>{{ t('common.bike.pedals') }}</h3>
      <span
        v-if="
          finalMeasurement.pedal.active.PEDAL_BRAND ||
          finalMeasurement.pedal.active.PEDAL_MODEL
        "
        >{{
          `${finalMeasurement.pedal.active.PEDAL_BRAND} ${finalMeasurement.pedal.active.PEDAL_MODEL}`
        }}</span
      >
      <h4>{{ t('common.specs') }}</h4>
      <div class="finished-setup__row">
        <span>{{ t('common.size.height') }}</span>
        <span v-if="finalMeasurement?.pedal.active.PEDAL_HEIGHT">{{
          `${finalMeasurement?.pedal.active.PEDAL_HEIGHT} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
    </div>

    <div class="finished-setup__bike-setup">
      <h3>{{ t('common.bike.setup') }}</h3>
      <h4>{{ t('common.distances') }}</h4>
      <div class="finished-setup__small">
        {{ t('measurement.tapeMeasure') }}
      </div>
      <div class="finished-setup__row">
        <span>{{ t('common.bike.saddleHeight') }}</span>
        <span v-if="bikeFinalSetup?.SADDLE_HEIGHT">{{
          `${bikeFinalSetup?.SADDLE_HEIGHT} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('common.bike.saddleHandlebar') }}</span>
        <span v-if="bikeFinalSetup?.SADDLE_HANDLEBAR_DISTANCE">{{
          `${bikeFinalSetup?.SADDLE_HANDLEBAR_DISTANCE} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
      <div class="finished-setup__row">
        <span>{{ t('common.bike.saddleHandlebarDrop') }}</span>
        <span v-if="bikeFinalSetup?.setupResult?.HandlebarDrop">{{
          `${bikeFinalSetup?.setupResult?.HandlebarDrop} ${t('common.unit.mm')}`
        }}</span>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()

const { bikeFinalSetup } = storeToRefs(bikeStore)
const { finalMeasurement } = storeToRefs(measurementStore)
</script>

<style lang="scss">
.finished-setup {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1.2rem;

  & > div {
    background-color: var(--color-dark-5);
    padding: 1.2rem;
    border-radius: 0.4rem;
  }

  h3 {
    margin-bottom: 0;
  }

  h4 {
    margin-top: 1.2rem;
    margin-bottom: 0.4rem;
    color: var(--color-dark-40);
  }

  &__row {
    display: flex;
    justify-content: space-between;
    font-family: 'Roboto Condensed';
    gap: 0.8rem;

    & > span:first-child {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    & > span:last-child {
      text-align: right;
      white-space: nowrap;
    }
  }

  &__saddle {
    grid-area: 1 / 1 / 3 / 2;
  }

  &__handlebar {
    grid-area: 1 / 2 / 3 / 3;
  }

  &__crankset {
    grid-area: 1 / 3 / 2 / 4;
  }

  &__pedals {
    grid-area: 2 / 3 / 3 / 4;
  }

  &__bike-setup {
    grid-area: 1 / 4 / 3 / 5;
  }

  &__small {
    margin: 1.2rem 0;
    font-size: 12px;
    color: var(--color-dark-40);
  }
}
</style>
